export default __webpack_public_path__ + "static/media/home-icon.4f6c8ac1.svg";